export const STYLE_CLASSES = {
  TOOLTIP_VISIBLE: 'tooltip-visible',
  TOOLTIP_HOVER: 'tooltip-hover',
  TOOLTIP_CLICK: 'tooltip-click-mode',
};
